<template>
    <ds-dropdown
        icons
        position="bottom-end"
        class="template-card-menu"
    >
        <template #default>
            <ds-icon-button name="more-vertical" dense />
        </template>

        <template #menu>
            <ul class="dropdown-menu-list">
                <li class="option dropdown-menu-item" @click="$emit('rename')">
                    <ds-icon class="option-icon" name="rename" />

                    <span>{{ $options.RENAME }}</span>
                </li>

                <li class="option dropdown-menu-item" @click="$emit('edit')">
                    <ds-icon class="option-icon" name="pencil" />

                    <span>{{ $options.EDIT }}</span>
                </li>

                <li class="option dropdown-menu-item" @click="$emit('copy')">
                    <ds-icon class="option-icon" name="copy" />

                    <span>{{ $options.COPY }}</span>
                </li>

                <li class="option dropdown-menu-item delete" @click="$emit('delete')">
                    <ds-icon class="option-icon" name="trash-2" />

                    <span>{{ $options.DELETE }}</span>
                </li>
            </ul>
        </template>
    </ds-dropdown>
</template>

<script>
export const RENAME = 'Rename';
export const EDIT = 'Edit';
export const COPY = 'Copy';
export const DELETE = 'Delete';

export default {
    RENAME,
    EDIT,
    COPY,
    DELETE,
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
.template-card-menu .dropdown-menu-list {
    padding: 0;
}
.option {
    --icon-color: #{$color-ink-800};
    color: $color-ink-900;

    &.delete {
        --icon-color: #{$color-red-800};
        color: $color-red;
    }
}
</style>
